import React from "react";
import { cn } from "@/lib/utils";

const sizeMap = {
  sm: "size-4 border-2",
  md: "size-6 border-2",
  lg: "size-10 border-[3px]",
} as const;

interface SpinnerProps {
  size?: keyof typeof sizeMap;
  /** @deprecated use size prop instead */
  px?: number;
  className?: string;
}

function Spinner({ size = "md", className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        "inline-block rounded-full animate-spin",
        "border-border border-t-primary",
        sizeMap[size],
        className,
      )}
    />
  );
}

export { Spinner };
